module.exports = __webpack_public_path__ + "28b67065/img/splash-icon.07a7c465.svg";